import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import {
  NOTIFICATION_LEVEL_ERROR,
  NOTIFICATION_LEVEL_SUCCESS,
} from '@avtechsoftware/ra-javascript-utilities/src/types/NotificationLevels';
import {
  selectSingleAlert,
  updateSingleAlertDescription,
} from '../../../../redux/slices/singleAlertSlice/singleAlertSlice';
import ClassUtility from '../../../../utility/ClassUtility';
import {
  pushSessionMessage,
} from '../../../../redux/slices/toastNotificationSlice/toastNotificationSlice';

const useHandleSubmitAlertDescription = () => {
  const alert = useSelector(selectSingleAlert);
  const dispatch = useDispatch();

  const handleUpdateDescription = (newName) => {
    const updatedAlert = ClassUtility.cloneObject(alert);
    updatedAlert.description = newName;
  };

  const handleSubmitDescription = (newName) => {
    handleUpdateDescription(newName);
    const params = new URLSearchParams();
    params.append('id', alert.id);
    params.append('name', newName);
    axios.post('/alerts/data/change-alert-name', params)
      .then(() => {
        dispatch(updateSingleAlertDescription({ description: newName }));
        dispatch(pushSessionMessage({
          level: NOTIFICATION_LEVEL_SUCCESS,
          title: 'Saved',
          body: 'Alert Description updated.',
        }));
      })
      .catch(() => {
        dispatch(pushSessionMessage({
          level: NOTIFICATION_LEVEL_ERROR,
          title: 'Error',
          body: 'Alert Description update failed unexpectedly.',
        }));
      });
  };

  return { handleSubmitDescription };
};

export default useHandleSubmitAlertDescription;
